<template>
  <div>
    <HeaderPage href="/culture"/>
    <div class="neiBanner">
        <div class="textBanner wow" >
            <dl>国正安全技术</dl>
            <dt>正念 / 正心 / 正言 / 正行</dt>
        </div>
    </div>
    <div class="honor wow">
        <div class="wrap">
            <div class="ntitle" >
                <h3>HONORS</h3>
                <h2>资质荣誉</h2>
            </div>
            <div class="box" >
              <ul class="flex flex-wrap">
                <li v-for="item in honorList" :key="item.id">
                  <a href="javascript:void(0);" @click="previewImage(item.src)">
                    <dl class="imgBoxCover"><img :src="item.src" :alt="item.title"></dl>
                    <h3>{{ item.title }}</h3>
                  </a>
                </li>
              </ul>
            </div>
        </div>
    </div>
    <FooterPage />

    <!-- 图片预览模态框 -->
    <div class="image-preview-modal" v-if="showPreview" @click="closePreview">
      <div class="modal-content">
        <img :src="currentImage" alt="Preview">
        <span class="close-btn" @click.stop="closePreview">×</span>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import axios from 'axios';

// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'


const honorList = ref([])

const showPreview = ref(false)
const currentImage = ref('')

const previewImage = (imgUrl) => {
  console.log(imgUrl)
  currentImage.value = imgUrl
  showPreview .value = true
  document.body.style.overflow = 'hidden';
}

const closePreview = () => {
  showPreview.value = false
  document.body.style.overflow = '';
}


let intervalId


const stopAutoScroll = () => {
  clearInterval(intervalId)
}

onMounted(async () => {

  try {
        const res = await axios.get('/mock/honorList.json'); // 本地Mock文件路径
        if (res.data.code === 200) {
          honorList.value = res.data.data
        }
    } catch (err) {
        console.error('获取失败：', err);
    }



  // ✅ 滚动动画逻辑
  const elements = document.querySelectorAll('.wow')
  const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const el = entry.target
      const animateName = el.dataset.animate || 'fadeInUp'
      if (entry.isIntersecting) {
        el.classList.add('animated', animateName)
        // ✅ 添加后立即取消观察，避免重复触发
        observer.unobserve(el)
      }
    })
  },
  { threshold: 0.2 }
)
  elements.forEach((el) => observer.observe(el))
  onUnmounted(() => {
    elements.forEach((el) => observer.unobserve(el))
    stopAutoScroll()
  })
})
</script>

<style scoped>
.neiBanner {
  height: 640px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background:url('@/assets/images/bg/WTUaAgoD.jpg');
}
.neiBanner .textBanner {
  color: #fff;
  text-align: center;
  font-weight: bold;
}
.neiBanner .textBanner dl {
  font-size: 72px;
}
.neiBanner .textBanner dt {
  font-size: 30px;
  font-weight: 500;
}
.honor {
  padding: 80px 0 150px;
}
.ntitle {
  text-align: center;
  margin-bottom: 50px;
}
.ntitle h3 {
  font-size: 38px;
  line-height: 1;
  color: #003366;
  font-weight: 500;
  border-bottom: #003366 solid 1px;
  display: inline-block;
  padding: 0 0 15px;
  margin-bottom: 15px;
}
.ntitle h2 {
  font-size: 36px;
  line-height: 1;
  color: #333;
  font-weight: 500;
}
.culture .box {
  padding: 65px;
  background: #f1f1f1;
}
.culture .box .pic,
.culture .box .textBox {
  width: 50%;
}
.culture .box .textBox ul {
  overflow: hidden;
}
.culture .box .textBox ul li {
  padding: 50px 0;
  border-top: 2px solid #023c6d;
  margin-top: -2px;
}
.culture .box .textBox ul li h3 {
  font-size: 36px;
  color: #023c6d;
  font-weight: 500;
}
.honor .box ul li dl img {
  padding: 15px;
}
.culture .box .textBox ul li dt {
  font-size: 24px;
}

.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.modal-content img {
  max-width: 100%;
  max-height: 80vh;
  border: 2px solid #fff;
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  color: white;
  font-size: 30px;
  cursor: pointer;
}
</style>